import React from "react";
import { Link } from "react-router-dom";

const PrivacyPolicy = () => {
  return (
    <div className="container-fluid">
      <div className="p-4">
        <h3
          className="text-center"
          style={{ color: "#1d364d", fontWeight: "600" }}
        >
          Privacy Policy
        </h3>
        <p>
          At Care-Exchange.com, we value your privacy and are committed to
          protecting your personal information. This Privacy Policy is designed
          to help you understand how we collect, use, disclose, and safeguard
          your personal information when you visit our website or use our
          products and services. By accessing our website or using our products
          and services, you consent to the practices described in this Privacy
          Policy. Please read this policy carefully to understand your rights
          and responsibilities regarding your personal information.
        </p>

        <h4 style={{ color: "#1d364d", fontWeight: "600" }}>
          Information We Collect
        </h4>
        <p>We may collect the following types of information:</p>
        <ul>
          <li>
            <b>Personal Information:</b> This may include your name, email
            address, phone number, postal address, and any other information you
            provide when filling out forms on our website or when contacting us.
          </li>
          <li>
            <b>Usage Information:</b> We may collect information about your
            interactions with our website and services, such as your IP address,
            browser type, operating system, and browsing behavior.{" "}
          </li>
          <li>
            <b>Cookies:</b> We use cookies and similar tracking technologies to
            collect information about your browsing preferences, such as the
            pages you visit, the links you click, and other actions you take on
            our website.
          </li>
        </ul>

        <h4 style={{ color: "#1d364d", fontWeight: "600" }}>
          How We Use Your Information
        </h4>
        <p>We may use your personal information for the following purposes:</p>
        <ul>
          <li>To provide and maintain our products and services.</li>
          <li>To communicate with you and respond to your inquiries.</li>
          <li>To improve and personalize your experience on our website.</li>
          <li>
            To send you marketing communications, promotions, newsletters, and
            updates if you have provided your consent.
          </li>
          <li>To monitor and analyze website usage and trends.</li>
        </ul>

        <h4 style={{ color: "#1d364d", fontWeight: "600" }}>
          Sharing Your Information
        </h4>
        <p>
          We may share your personal information with third parties, including:
        </p>
        <ul>
          <li>
            <b>Service Providers:</b> We may share information with trusted
            service providers who assist us in providing our products and
            services and maintaining our website.
          </li>
          <li>
            <b>Legal Requirements:</b> We may disclose your information if
            required by law, such as in response to a court order or government
            request.
          </li>
        </ul>

        <h4 style={{ color: "#1d364d", fontWeight: "600" }}>Your Choices</h4>
        <p>
          You have the following choices regarding your personal information:
        </p>
        <ul>
          <li>
            <b>Access and Correction:</b> You can access, update, or correct
            your personal information by contacting us.
          </li>
          <li>
            <b>Opt-Out:</b> You can opt out of receiving marketing
            communications by following the instructions in the communication.
          </li>
        </ul>

        <h4 style={{ color: "#1d364d", fontWeight: "600" }}>Data Security</h4>
        <p>
          We employ reasonable security measures to protect your personal
          information from unauthorized access, disclosure, alteration, and
          destruction.
        </p>
        <p>
          <b>Do Not Track (“DNT”)</b> is a privacy preference that users can set
          in certain web browsers. DNT is a way for users to inform websites and
          services that they do not want certain information about their web
          page visits collected over time and across websites or online
          services. Please note that we do not respond to or honor DNT signals
          or similar mechanisms transmitted by web browsers.
        </p>
        <p>
          Care-Exchange.com uses a browser feature known as a cookie. A cookie
          is a simple file that stores your personalized information on your
          hard drive so you don't have to re-enter it a second time when
          revisiting our website. Cookies help to improve and personalize your
          shopping experience by increasing our web pages responsiveness and
          decreasing time between downloading as you browse or surf through our
          website.
        </p>

        <h4 style={{ color: "#1d364d", fontWeight: "600" }}>
          California Privacy Rights under the CCPA:
        </h4>
        <p>
          The following information is regarding the personal data we collect on
          consumers from the state of California and their rights supplied to
          them due to the California Consumer Act.
        </p>
        <p>
          We understand that the CCPA or the California Consumer Act allows
          consumers to opt-out of any data collection strategies, to ask for
          details regarding specific pieces of personal information, and request
          to have certain personal information deleted. We do not discriminate
          against consumers for using these afforded rights.
        </p>
        <p>
          <b>We have collected the following types of data:</b> Identifiers
          (such as name, email address, postal address, phone number, IP
          Address) Commercial information (transactional information, purchase
          history, payment info)
        </p>
        <p>
          <b>Location Information</b>
        </p>
        <p>We collect location information in the following ways:</p>
        <ul>
          <li>
            Directly from You – When you provide a delivery address or other
            location details.
          </li>
          <li>
            Automatically – Through GPS, WiFi, wireless network triangulation,
            or other methods. We may also infer your location based on your IP
            address or other data.
          </li>
        </ul>
        <p>We use location information to:</p>
        <ul>
          <li>
            Personalize content on our services, such as displaying available
            restaurants and relevant perks.
          </li>
          <li>Facilitate order processing and delivery services.</li>
        </ul>
        <p>
          If you have enabled location tracking for our mobile application, we
          may collect and store your device’s precise location while the app
          runs in the foreground or background. You can disable this feature by
          adjusting your device’s settings.
        </p>
        <p>
          Additionally, we use the Google Maps API to gather location data.
          Google may collect location details using various technologies, such
          as IP address, GPS, and nearby WiFi or cell towers. For more
          information, please review the{" "}
          <Link
            style={{ textDecoration: "underline", color: "#6c6ce9" }}
            to={"https://policies.google.com/privacy"}
          >
            Google Privacy Policy
          </Link>{" "}
          and{" "}
          <Link
            style={{ textDecoration: "underline", color: "#6c6ce9" }}
            to={"https://maps.google.com/help/terms_maps"}
          >
            Google Maps Terms of Service
          </Link>
          .
        </p>
        <p>
          <b>Browsing history on our site</b>
        </p>
        <p>
          Please know that we use third-party cookies to assist us with
          advertising, this also helps us to analyze and track data based on
          your time spent and the pages visited on our website. We use this
          information to help provide you with a better shopping experience.
        </p>
        <p>
          Please know that we use third-party cookies to assist us with
          advertising, this also helps us to analyze and track data based on
          your time spent and the pages visited on our website. We use this
          information to help provide you with a better shopping experience.
        </p>
        <p>
          We use and disclose the categories of personal information we collect
          from and about you consistent with the business purposes discussed in
          the section “How We Use Your Information”.
        </p>
        <p>
          The CCPA also sets forth obligations for businesses that "sell”
          personal information to third parties. We do not “sell” personal
          information and have not sold any personal information in the past 12
          months.
        </p>
        <p>
          The CCPA also sets forth obligations for businesses that "sell”
          personal information to third parties. We do not “sell” personal
          information and have not sold any personal information in the past 12
          months.
        </p>
        <p>
          Right to know about personal information collected, used, disclosed,
          or sold. You have the right to request that we disclose to you the
          categories of personal information we collect or disclose (or have
          collected or disclosed in the past 12 months) about you, the
          categories of sources of such information, the business or commercial
          purpose for collecting your personal information, and the categories
          of third parties with whom we share/disclose personal information.
          This information is also explained throughout this Privacy Policy.
        </p>
        <p>
          Right to request deletion of personal information. You have the right
          to request the deletion of the personal information we have collected
          from you, subject to certain conditions and limitations under the law.
        </p>
        <p>
          Right to Opt-Out of the sale of personal information. The CCPA
          provides consumers with the right to opt-out of the sale of their
          personal information. We do not share, sell, rent, or trade User
          Personal Information with third parties for their commercial purposes
          as defined under the CCPA.
        </p>
        <p>
          Right to non-discrimination for exercising a consumer privacy right.
          We will not discriminate against you for exercising any of your rights
          under the CCPA.
        </p>
        <p>
          To exercise any of your rights as set out above on or after January 1,
          2020, and are a California resident, please contact us by submitting a
          request at DSAR Form or by contacting us at 7910 S 3500 E, Suite C,
          SLC 84121. You will be required to verify your identity before we are
          able to fulfill your request.
        </p>
        <h4 style={{ color: "#1d364d", fontWeight: "600" }}>
          About Credit Card Transactions
        </h4>
        <p>
          <b>Can I safely transmit information such as credit card numbers?</b>
        </p>
        <p>
          You can enter your credit card number on a secure (https) form and
          transmit the form over the Internet to a secure server without risk of
          an intermediary obtaining your credit card information. The security
          features offered by your web browser technology protects commercial
          transactions, as well as all other communications, from
          misappropriation and fraud that could otherwise occur as information
          passes through the internet.
        </p>
        <p>
          Furthermore, with SSL implemented on both the client and server, your
          internet communications are transmitted in an encrypted form. The
          information you send can be trusted to arrive privately and unaltered
          to the server you specify (and no other).
        </p>
        <p>
          SSL uses authentication and encryption technology. For example, your
          browsers export implementation of SSL (U.S. government approved) uses
          a high-grade, 128-bit key size. The encryption established between you
          and a server remains valid over multiple connections, yet the effort
          expended to defeat the encryption of one message cannot be leveraged
          to defeat the next message.
        </p>
        <p>
          Your browser and secure servers deliver server authentication using
          signed digital certificates issued by trusted third parties known as
          certificate authorities, via McAfee Secure. A digital certificate
          verifies the connection between a server's public key and the server's
          identification (just as a driver's license verifies the connection
          between your photograph and your personal identification.)
          Cryptographic checks, using digital signatures, ensure that
          information within a certificate can be trusted.
        </p>
        <h4 style={{ color: "#1d364d", fontWeight: "600" }}>
          Changes to This Privacy Policy
        </h4>
        <p>
          We may update this Privacy Policy to reflect changes in our practices
          or legal requirements. Any updates will be posted on our website, and
          the “Last Updated” date will be modified accordingly.
        </p>
        <h4 style={{ color: "#1d364d", fontWeight: "600" }}>Contact Us</h4>
        <p>
          If you have any questions or concerns regarding this Privacy Policy or
          your personal information, please Contact us.
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
